import { Box, Divider, IconButton, Typography, MenuItem } from "@mui/material";
import React, { useState } from "react";
// import { Link } from "react-router-dom";
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import Select from '@mui/joy/Select';
import Option from '@mui/joy/Option';
import Chip from '@mui/joy/Chip';
import FavoriteBorder from '@mui/icons-material/FavoriteBorder';





const Breadcrumb = (props) => {
    const { title, parent, title1, title2, title3, title4, title5 } = props;
    return (
        <React.Fragment>
            <div className={`breadcrumb-area pt--221`}>

                <div className="section-container">
                    <div className="breadcrumb-container">
                        <div className="breadcrumb-inner-1" style={{ left: "50%", right: "50%", transform: "translate(-50)" }}>
                            <ul className="page-list">
                                {/* <li className="breadcrumb-item"><Link to={`/`}>Home</Link></li> */}
                                {parent ? <li className="breadcrumb-item">{parent}</li> : ''}
                                {title ? <li className="breadcrumb-item">{title}</li> : ''}
                                {title1 ? <li className="breadcrumb-item">{title1}</li> : ''}
                                {title2 ? <li className="breadcrumb-item">{title2}</li> : ''}
                                {title3 ? <li className="breadcrumb-item">{title3}</li> : ''}
                                {title4 ? <li className="breadcrumb-item">{title4}</li> : ''}
                                {title5 ? <li className="breadcrumb-item">{title5}</li> : ''}
                            </ul>
                        </div>

                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export const BreadcrumbTwo = ({ order = '', orderBy = '', handleSortChange }) => {
    // const { title, parent, title1, title2, title3, title4, title5 } = props;

    const combinedValue = `${order}-${orderBy}`;

    return (
        <React.Fragment>
            <Box
                sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: 0,
                    p: 2,
                    height: '50px',
                }}
            >
                <Box
                    sx={{
                        width: 230,
                        height: '50px',
                        display: 'flex',
                        alignItems: 'center',
                        flexWrap: 'wrap',

                        justifyContent: 'space-between',

                    }}
                >
                    <Typography level='body-sm' sx={{ fontSize: '16px', fontWeight: 400, lineHeight: '33px', m: 'auto' }}>Bid</Typography>

                    <Divider orientation="vertical" flexItem
                        sx={{
                            margin: '0',
                            width: '3px',
                            backgroundColor: '#666666',
                            opacity: '0.2',
                        }}

                    />
                </Box>
                <Box
                    sx={{
                        width: 230,
                        height: '50px',
                        display: 'flex',
                        alignItems: 'center',
                        flexWrap: 'wrap',

                        justifyContent: 'space-between',

                    }}
                >
                    <Typography level='body-sm' sx={{ fontSize: '16px', fontWeight: 400, lineHeight: '33px', m: 'auto' }}>  Active Job</Typography>

                    <Divider orientation="vertical" flexItem
                        sx={{
                            margin: '0',
                            width: '3px',
                            backgroundColor: '#666666',
                            opacity: '0.2',
                        }} />
                </Box>

                <Box
                    sx={{
                        width: 230,
                        height: '50px',

                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    Past job
                </Box>
                <Box
                    sx={{
                        width: '400px',
                        height: '50px',

                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'end',
                    }}
                >
                    
                 
                    <Select
                value={combinedValue}
                onChange={(event, newValue) => {
                    console.log('Selected Value:', newValue); // Verify correct value
                    handleSortChange(newValue);
                }}
                placeholder="Filter"
            
                endDecorator={
                    <FilterAltOutlinedIcon sx={{ color: 'black' }} />
                }
                sx={{ width: 150,textAlign:'center' }}
            >
            <Option value=""></Option>
                <Option value="asc-price">Ascending to Price</Option>
                <Option value="desc-price">Descending to Price</Option>
                <Option value="asc-rating">Ascending to Rating</Option>
                <Option value="desc-rating">Descending to Rating</Option>
            </Select>
                </Box>

            </Box>

           

           
        </React.Fragment>
    )
}

export default Breadcrumb;

